import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useIsSuperAdmin } from './useIsSuperAdmin';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

/**
 * Client-side gate for `/admin/*`.
 *
 * Uses `useIsSuperAdmin`, which probes `GET /admin/console/whoami` so the UI
 * matches the server gate (claim + allowlist + MFA). Non-admins are bounced
 * silently to home.
 */
export const SuperAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const { isSuperAdmin, loading: checking } = useIsSuperAdmin();

  if (authLoading || checking) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-[#0d121b]">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!isSuperAdmin) {
    // Don't reveal the existence of the admin console — bounce silently to home.
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
